export default __webpack_public_path__ + "static/media/what-we-do.01a140bf.jpg";